/**
 * Complianz Cookie
 * https://wordpress.org/plugins/complianz-gdpr/
 *
 * TODO: Inform the developers. The event listener fires four times and has inconsistent data. As a consequence PMW has to update the consent status also four times which is inefficient.
 */

/**
 * Whether an unset category may be read as consent, following Complianz' own
 * cmplz_has_consent(): under the "optout" and "other" consent types it may,
 * under "optin" (the GDPR default) only an explicit "allow" counts.
 *
 * While the consent type is still unknown, which is the case when Complianz'
 * own script has not run yet, an unset category must not grant anything in
 * explicit consent mode.
 *
 * @returns {boolean}
 */
const impliedConsentApplies = () => {

	const consentType = window.complianz?.consenttype

	if (consentType) return consentType === "optout" || consentType === "other"

	return !pmw.consent.explicitConsentModeActive()
}

/**
 * @param value {string} - the raw cookie value
 * @returns {boolean}
 */
const hasConsent = (value) => {

	if (value === "allow") return true
	if (value !== "") return false

	return impliedConsentApplies()
}

export const complianz = {

	/**
	 * Get the Complianz cookies
	 *
	 * @returns {{statistics: boolean, marketing: boolean, preferences: boolean, necessary: boolean}|null}
	 */
	getConsent: () => {

		const values = {
			statistics : pmw.getCookie("cmplz_statistics") || pmw.getCookie("cmplz_rt_statistics"),
			marketing  : pmw.getCookie("cmplz_marketing") || pmw.getCookie("cmplz_rt_marketing"),
			preferences: pmw.getCookie("cmplz_preferences") || pmw.getCookie("cmplz_rt_preferences"),
			necessary  : pmw.getCookie("cmplz_functional") || pmw.getCookie("cmplz_rt_functional"),
		}

		const bannerStatus = pmw.getCookie("cmplz_consent_status") || pmw.getCookie("cmplz_banner-status") || pmw.getCookie("cmplz_rt_banner-status")

		/**
		 * Only a category cookie carries a visitor decision. Complianz also writes
		 * a banner status when it merely wants the banner shown again, for example
		 * for a new cookie policy revision or after a click on "manage consent",
		 * and it clears the category cookies while doing so. Without a category
		 * cookie PMW must not derive any consent, otherwise the mere presence of
		 * the banner cookie unblocks every pixel before the visitor has answered
		 * the banner. Sibling of the Cookie Script fix in 1.65.0.
		 */
		if (!Object.values(values).some(value => value !== "")) {

			if (bannerStatus) {
				pmw.console.log("Complianz cookie detected, but the visitor hasn't answered the banner yet. Ignoring it.")
			}

			return null
		}

		pmw.console.log("Complianz CMP consent detected")

		return {
			statistics : hasConsent(values.statistics),
			marketing  : hasConsent(values.marketing),
			preferences: hasConsent(values.preferences),
			// Functional is always allowed unless it has been denied explicitly.
			necessary  : values.necessary !== "deny",
		}
	},

	/**
	 * Complianz Cookie
	 *
	 * If visitor accepts cookies in Complianz unblock the scripts
	 */
	loadEventListeners: () => {
		document.addEventListener("cmplz_fire_categories", cmplzStatusChange, true)
	},
}

/**
 * Complianz
 *
 * @param consent
 */
const cmplzStatusChange = (consent) => {

	let data = {
		statistics : consent.detail.categories.includes("statistics"),
		marketing  : consent.detail.categories.includes("marketing"),
		preferences: consent.detail.categories.includes("preferences"),
		necessary  : consent.detail.categories.includes("functional"),
		source     : "cmp",
	}

	pmw.consent.api.updateSelectively(data)
}
